import {Container} from 'pixi.js';
import {ScreenParameters} from '@gongxigames/framework/core/fragments/ScreenParameters';

export type FullScreenContainerOptions = {
    contentWidth: number;
    contentHeight: number;
    name?: string;
    screenParameters?: ScreenParameters;
};

export class FullScreenContainer extends Container {
    public contentWidth: number;
    public contentHeight: number;

    // @ts-ignore
    constructor(
        public readonly options: FullScreenContainerOptions
    ) {
        const {name = 'FullScreenContainer', screenParameters} = options;

        super();

        this.contentWidth = options.contentWidth;
        this.contentHeight = options.contentHeight;
        this.name = name;

        if (screenParameters) {
            this.resize(screenParameters);
        }
    }

    public resize(screenParameters: ScreenParameters): this {
        const {contentWidth, contentHeight} = this;
        const props = screenParameters.calcScreenFillProps(contentWidth, contentHeight);

        this.scale.set(props.scale);
        this.position.set(props.x, props.y);

        return this;
    }
}
